import { Component, Input } from '@angular/core';

import { TaskFeasibilityInfo } from '../models/task-feasibility-info.model';

@Component({
    selector: 'app-feasibility-info',
    templateUrl: './task-feasibility-info.component.html',
    styleUrls: ['./task-feasibility-info.component.scss'],
    standalone: false
})
export class TaskFeasibilityInfoComponent {
    @Input() public feasibilityInfo: TaskFeasibilityInfo;
    @Input() public showOvertime: boolean;

    constructor() {}
}
